const state = {
  pinedToHomePage: [],
  signworkflowsVueOrder: [],
  socialSignatoriesVueOrder: [],
};

export default state;
